import { Suspense } from "react"
import { Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../shared/components/loading/LoadingSpinner"
import { ConferenceInfo } from "../components/ConferenceInfo"
import { VideoSection } from "../components/VideoSection"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        position: "relative",
        height: "100vh",
        overflow: "hidden",
    },
}))

export function Conference() {
    const { classes } = useStyles()

    return (
        <Grid container className={classes.wrap}>
            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <VideoSection />
                </Suspense>
            </QueryErrorBoundary>
            <ConferenceInfo />
        </Grid>
    )
}
